import React from 'react'

import {
    setToggleTrue,
    setDownloadBrochureTrue
} from '../redux/slice/changeState';

import { useDispatch } from 'react-redux';

import { Container, Row, Col } from 'react-bootstrap'
import { useMediaQuery } from 'react-responsive';

import image from '../images/prime.webp'
import { FaMapMarkerAlt } from "react-icons/fa";
import p1 from '../images/p1.webp'
import p10 from '../images/p10.webp'
import p2 from '../images/p2.webp'
import p3 from '../images/p3.webp'
import p4 from '../images/p4.webp'
import p5 from '../images/p5.webp'
import p6 from '../images/p6.webp'
import p7 from '../images/p7.webp'
import p8 from '../images/p8.webp'
import p9 from '../images/p9.webp'

const ChooseMiracle = () => {
    const dispatch = useDispatch();

    const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
    return (
        <>
            <div className='modern-section ' style={{ paddingTop: "5%", paddingBottom: "5%", paddingLeft: "5%", paddingRight: 0 }}>
                <Container>
                    <Row>
                        <Col lg={7} md={12} xs={12}>
                            <div className={`${isMobile ? 'text-start' : ''}`}>
                                <h1 className='primary-color'>Why Choose:</h1>
                                <h1 className='primary-color'>IRA Miracle in Kollur?</h1>
                                <br />
                            </div>
                            <Row className={`${isMobile ? 'mb-2' : 'mb-4'} gx-2`} style={{ padding: isMobile ? '0px 0px 0px 16px' : '' }}>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className='w-100 facility-row'>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={p1} alt="" className='img-fluid' ></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div >
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>Project Name:</p>
                                                        <p className='sec-span'>IRA Miracle</p>
                                                    </>
                                                    :
                                                    <>
                                                        <span className='first-span'>Project Name:</span><br />
                                                        <span className='sec-span'>IRA Miracle</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className={`w-100 facility-row`}>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={p10} alt="" className='img-fluid' ></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div >
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>Area</p>
                                                        <p className='sec-span'>3 Acres</p>
                                                    </>
                                                    :
                                                    <>
                                                        <span className='first-span'>Area</span><br />
                                                        <span className='sec-span'>3 Acres</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className={`${isMobile ? 'mb-2' : 'mb-4'} gx-2`} style={{ padding: isMobile ? '0px 0px 0px 16px' : '' }}>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className='w-100 facility-row'>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={p5} alt="" className='img-fluid'></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div>
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>Status</p>
                                                        <p className='sec-span'>Ready to Move In</p>
                                                    </>
                                                    :
                                                    <>
                                                        <span className='first-span'>Status</span><br />
                                                        <span className='sec-span'>Ready to Move In</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className={`w-100 facility-row`}>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={p3} alt="" className='img-fluid'></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div>
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>Total Flats</p>
                                                        <p className='sec-span'>274</p>
                                                    </>
                                                    :
                                                    <>
                                                        <span className='first-span'>Total Flats</span><br />
                                                        <span className='sec-span'>274</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className={`${isMobile ? 'mb-2' : 'mb-4'} gx-2`} style={{ padding: isMobile ? '0px 0px 0px 16px' : '' }}>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className='w-100 facility-row'>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={p4} alt="" className='img-fluid'></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div>
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>Flat Area</p>
                                                        <p className='sec-span'>1655 To 2455 Sq. Ft.</p>
                                                    </>
                                                    :
                                                    <>
                                                        <span className='first-span'>Flat Area</span><br />
                                                        <span className='sec-span'>1655 To 2455 Sq. Ft.</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className={`w-100 facility-row`}>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={p6} alt="" className='img-fluid'></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div>
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>Structure</p>
                                                        <p className='sec-span'>2B+G+14F</p>
                                                    </>
                                                    :
                                                    <>
                                                        <span className='first-span'>Structure</span><br />
                                                        <span className='sec-span'>2B+G+14F</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className={`${isMobile ? 'mb-2' : 'mb-4'} gx-2`} style={{ padding: isMobile ? '0px 0px 0px 16px' : '' }}>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className='w-100 facility-row'>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={p2} alt="" className='img-fluid'></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div>
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>Unit Type</p>
                                                        <p className='sec-span'>3 BHK</p>
                                                    </>
                                                    :
                                                    <>
                                                        <span className='first-span'>Unit Type</span><br />
                                                        <span className='sec-span'>3 BHK</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className={`w-100 facility-row`}>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={p7} alt="" className='img-fluid'></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div>
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>Club House</p>
                                                        <p className='sec-span'>20500 SFT</p>
                                                    </>
                                                    :
                                                    <>
                                                        <span className='first-span'>Club House</span><br />
                                                        <span className='sec-span'>20500 SFT</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className={`${isMobile ? 'mb-2' : 'mb-4'} gx-2`} style={{ padding: isMobile ? '0px 0px 0px 16px' : '' }}>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className='w-100 facility-row'>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={p8} alt="" className='img-fluid'></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div>
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>Pricing</p>
                                                        <p className='sec-span'>₹6,499/Sq. Ft.</p>
                                                    </>
                                                    :
                                                    <>
                                                        <span className='first-span'>Pricing</span><br />
                                                        <span className='sec-span'>₹6,499/Sq. Ft.</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className={`w-100 facility-row`}>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={p9} alt="" className='img-fluid'></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div>
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>RERA NO</p>
                                                        <p className='sec-span'>P01100002811</p>
                                                    </>
                                                    :
                                                    <>
                                                        <span className='first-span'>RERA NO</span><br />
                                                        <span className='sec-span'>P01100002811</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>

                                    </Row>

                                </Col>
                                <Col className='mt-5'>
                                    <a
                                        onClick={() => {
                                            dispatch(setDownloadBrochureTrue());
                                            dispatch(setToggleTrue());
                                        }}
                                        className="primary-btns text-decoration-none"
                                        style={{ cursor: "pointer" }}
                                    >
                                        Download Brochure Now
                                    </a>
                                </Col>

                            </Row>
                        </Col>
                        <Col lg={5} md={12} xs={12} className={`${isMobile ? 'mt-3' : 'd-flex justify-content-end'} position-relative`}>
                            {
                                isMobile ?
                                    <>
                                        <div className='d-flex align-items-center prime-kollur position-absolute'>
                                            <FaMapMarkerAlt size={isMobile ? 15 : 30} />
                                            <h6>Prime Kollur</h6>
                                        </div>
                                        <div className='text-center'>
                                            <img src="/choosem.png" className='img-fluid' alt="section2-img" style={{ width: '80%' }}></img>
                                        </div>

                                    </>
                                    :
                                    <>
                                        <div className='w-100'>
                                            <div className='d-flex position-absolute prime-kollur align-items-center'>
                                                <FaMapMarkerAlt size={isMobile ? 15 : 30} />
                                                <h6>Prime Kollur</h6>
                                            </div>
                                        </div>
                                        <div
                                            className="position-absolute first-img end-0"
                                        >
                                            <img
                                                src="choose.png"
                                                className="img-fluid"
                                                alt="section2-img"
                                            />
                                        </div>
                                    </>
                            }

                        </Col>
                    </Row>
                </Container>
            </div>

        </>
    )
}

export default ChooseMiracle
